// extracted by mini-css-extract-plugin
export var icon = "product-type-icon-module--icon--dC5Xg";